export const googleClientID: string =
  '363298867716-rf7g4r7jcinr0ml0ojhkd45le3udt2gd.apps.googleusercontent.com';

export const loginText: string = 'Sign In';
export const logoutText: string = 'Sign Out';
